import Strings from '../../Strings';

// The backend only sends orders worth warning about, so anything present here
// is shown as-is.
export function unlinkedHardwareTooltip(unlinkedOrders) {
  if (!unlinkedOrders?.length) {
    return '';
  }
  const lines = unlinkedOrders.map(order => 
    `${order.order_uuid} · ${order.status}${order.shipment_status ? ` · ${Strings.formatString(Strings.shipping.unlinkedHardwareShipped, order.shipment_status)}` : ''}`
  );
  return [
    Strings.formatString(Strings.shipping.unlinkedHardwareWarning, unlinkedOrders.length),
    ...lines,
  ].join('\n');
}
